module.exports = __webpack_public_path__ + "static/media/abbiamo16.ed13412c.png";